import { defineStore } from 'pinia';

export const aanvullendeDekkingenStore = defineStore({
  id: 'aanvullendeDekkingen',
  state: () => ({
    aanvullendedekkingen: null,
    alleaanvullendedekkingen: {},
  }),
  getters: {
    hasAlleAanvullendeDekkingen() {
      return this.alleaanvullendedekkingen !== null && Object.keys(this.alleaanvullendedekkingen).length !== 0;
    },
    getAlleAanvullendeDekkingen(state) {
      return state.alleaanvullendedekkingen;
    },
    getTotalAmountSelected(state) {
      let amount = 0;
      const group_keys = Object.keys(state.alleaanvullendedekkingen);
      group_keys.forEach((group) => {
        const coverage_keys = Object.keys(state.alleaanvullendedekkingen[group]);
        coverage_keys.forEach((key) => {
          amount = state.alleaanvullendedekkingen[group][key].selected
            ? amount + state.alleaanvullendedekkingen[group][key].premie
            : amount;
        });
      });
      return amount;
    },
  },
  actions: {
    setAanvullendeDekkingen(value) {
      this.aanvullendedekkingen = value;
    },
    setAlleAanvullendeDekkingen(value) {
      this.alleaanvullendedekkingen = value;
    },
  },
  persist: true,
});
